/*
  Isekaid Black Rune Cursor — Clean Version
  File: assets/isekaid-rune-cursor.js
*/

(() => {
  const finePointer = window.matchMedia(
    '(hover: hover) and (pointer: fine)'
  );

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  if (!finePointer.matches || reducedMotion.matches) {
    return;
  }

  const cursor = document.createElement('div');

  cursor.className = 'isekaid-rune-cursor';
  cursor.setAttribute('aria-hidden', 'true');

  cursor.innerHTML = `
    <div class="isekaid-rune-cursor__circle">
      <svg
        class="isekaid-rune-cursor__circle-svg"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="32"
          cy="32"
          r="27"
          fill="rgba(0, 0, 0, 0.14)"
          stroke="#FFFFFF"
          stroke-width="1"
          opacity="0.9"
        />

        <circle
          cx="32"
          cy="32"
          r="22.5"
          fill="none"
          stroke="#FFFFFF"
          stroke-width="0.65"
          opacity="0.55"
        />

        <g
          class="isekaid-rune-cursor__outer-runes"
          fill="none"
          stroke="#FFFFFF"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
          opacity="0.9"
        >
          <path d="M32 3 L29.5 7 L34.5 7 Z" />
          <path d="M32 61 L29.5 57 L34.5 57 Z" />
          <path d="M3 32 L7 29.5 L7 34.5 Z" />
          <path d="M61 32 L57 29.5 L57 34.5 Z" />

          <path d="M11 11 L15 12 L12 16" />
          <path d="M53 11 L49 12 L52 16" />
          <path d="M11 53 L15 52 L12 48" />
          <path d="M53 53 L49 52 L52 48" />

          <path d="M19 5.5 L22 9.5 L18 10 Z" />
          <path d="M45 5.5 L42 9.5 L46 10 Z" />
          <path d="M19 58.5 L22 54.5 L18 54 Z" />
          <path d="M45 58.5 L42 54.5 L46 54 Z" />

          <path d="M5.5 19 L9.5 22 L10 18 Z" />
          <path d="M58.5 19 L54.5 22 L54 18 Z" />
          <path d="M5.5 45 L9.5 42 L10 46 Z" />
          <path d="M58.5 45 L54.5 42 L54 46 Z" />
        </g>

        <g
          class="isekaid-rune-cursor__inner-runes"
          fill="none"
          stroke="#FFFFFF"
          stroke-width="1.1"
          stroke-linecap="round"
          stroke-linejoin="round"
          opacity="0.84"
        >
          <path d="M32 32 L32 13 M29 17 L32 13 L35 17" />
          <path d="M32 32 L45.5 18.5 M41 19 L45.5 18.5 L45 23" />
          <path d="M32 32 L51 32 M47 29 L51 32 L47 35" />
          <path d="M32 32 L45.5 45.5 M45 41 L45.5 45.5 L41 45" />
          <path d="M32 32 L32 51 M29 47 L32 51 L35 47" />
          <path d="M32 32 L18.5 45.5 M23 45 L18.5 45.5 L19 41" />
          <path d="M32 32 L13 32 M17 29 L13 32 L17 35" />
          <path d="M32 32 L18.5 18.5 M19 23 L18.5 18.5 L23 19" />
        </g>

        <circle
          cx="32"
          cy="32"
          r="5.2"
          fill="#050505"
          stroke="#FFFFFF"
          stroke-width="0.9"
        />

        <circle
          cx="32"
          cy="32"
          r="1.8"
          fill="#FFFFFF"
        />
      </svg>
    </div>

    <div class="isekaid-rune-cursor__pointer">
      <!-- Clean normal arrow -->
      <svg
        class="isekaid-rune-cursor__arrow"
        viewBox="0 0 24 31"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="
            M2.5 2
            L19.5 17.5
            L13.1 18.4
            L17 27.3
            L12.8 29
            L9.1 20.1
            L4.5 24.4
            Z
          "
          fill="#080808"
          stroke="#FFFFFF"
          stroke-width="1.3"
          stroke-linejoin="round"
        />
      </svg>

      <!-- Clean custom clickable hand -->
      <svg
        class="isekaid-rune-cursor__hand"
        viewBox="0 0 24 30"
        xmlns="http://www.w3.org/2000/svg"
      >
        <!--
          The index-finger tip is centered at x=12, y=1,
          which matches the rune circle's center point.
        -->
        <path
          d="
            M9.9 4.1
            C9.9 2.2 10.7 1 12 1
            C13.3 1 14.1 2.2 14.1 4.1
            V11.2

            C14.1 9.9 14.9 9.1 16 9.1
            C17.2 9.1 18 10 18 11.3
            V12.2

            C18 11.1 18.8 10.4 19.9 10.4
            C21.1 10.4 21.8 11.3 21.8 12.6
            V13.5

            C21.8 12.5 22.5 11.9 23.4 11.9
            C24.4 11.9 25 12.8 24.9 14

            L24.3 20.8

            C24 25.2 20.9 28.7 16.3 29
            C11.5 29.3 8.1 26.8 6.4 23.4

            L2.3 17.5

            C1.5 16.3 1.8 15.1 2.8 14.4
            C3.8 13.7 5 14 5.8 15

            L9.9 19.3
            Z
          "
          fill="#080808"
          stroke="#FFFFFF"
          stroke-width="1.25"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <div class="isekaid-rune-cursor__click-pulse"></div>
  `;

  document.body.appendChild(cursor);

  const clickPulse = cursor.querySelector(
    '.isekaid-rune-cursor__click-pulse'
  );

  let pointerX = -100;
  let pointerY = -100;
  let isVisible = false;
  let frameRequested = false;
  let clickTimer = null;

  const INTERACTIVE_SELECTOR = [
    'a',
    'button',
    'summary',
    '[role="button"]',
    'input[type="submit"]',
    'input[type="button"]',
    '.isekaid-hotspot',
    '.product-card',
    '.card-wrapper',
    '.isekaid-creator-card',
    '.isekaid-hotspots__detail-link'
  ].join(',');

  const updatePosition = () => {
    frameRequested = false;

    cursor.style.setProperty(
      '--cursor-x',
      `${pointerX}px`
    );

    cursor.style.setProperty(
      '--cursor-y',
      `${pointerY}px`
    );
  };

  const requestPositionUpdate = () => {
    if (frameRequested) return;

    frameRequested = true;

    window.requestAnimationFrame(updatePosition);
  };

  const getInteractiveElement = (x, y) => {
    return document
      .elementFromPoint(x, y)
      ?.closest(INTERACTIVE_SELECTOR);
  };

  /*
    Brighten the circle as the mouse approaches an interactive
    element, even before it fully reaches it.
  */
  const isNearInteractiveElement = (x, y) => {
    const radius = 34;

    const samplePoints = [
      [x, y],
      [x + radius, y],
      [x - radius, y],
      [x, y + radius],
      [x, y - radius],
      [x + radius * 0.7, y + radius * 0.7],
      [x - radius * 0.7, y + radius * 0.7],
      [x + radius * 0.7, y - radius * 0.7],
      [x - radius * 0.7, y - radius * 0.7]
    ];

    return samplePoints.some(([sampleX, sampleY]) => {
      return Boolean(
        getInteractiveElement(sampleX, sampleY)
      );
    });
  };

  const updateState = (x, y) => {
    const interactive = getInteractiveElement(x, y);

    cursor.classList.toggle(
      'is-interactive',
      Boolean(interactive)
    );

    cursor.classList.toggle(
      'is-near-interactive',
      !interactive && isNearInteractiveElement(x, y)
    );
  };

  const showCursor = () => {
    if (isVisible) return;

    isVisible = true;
    cursor.classList.add('is-visible');
  };

  const hideCursor = () => {
    isVisible = false;

    cursor.classList.remove(
      'is-visible',
      'is-interactive',
      'is-near-interactive',
      'is-clicking'
    );
  };

  window.addEventListener(
    'pointermove',
    (event) => {
      if (event.pointerType !== 'mouse') return;

      pointerX = event.clientX;
      pointerY = event.clientY;

      showCursor();
      requestPositionUpdate();
      updateState(pointerX, pointerY);
    },
    { passive: true }
  );

  window.addEventListener(
    'pointerdown',
    (event) => {
      if (event.pointerType !== 'mouse') return;

      cursor.classList.add('is-clicking');

      cursor.style.setProperty(
        '--click-x',
        `${event.clientX}px`
      );

      cursor.style.setProperty(
        '--click-y',
        `${event.clientY}px`
      );

      clickPulse.classList.remove('is-active');

      void clickPulse.offsetWidth;

      clickPulse.classList.add('is-active');

      window.clearTimeout(clickTimer);

      clickTimer = window.setTimeout(() => {
        cursor.classList.remove('is-clicking');
      }, 170);
    },
    { passive: true }
  );

  window.addEventListener(
    'pointerup',
    () => {
      window.clearTimeout(clickTimer);

      clickTimer = window.setTimeout(() => {
        cursor.classList.remove('is-clicking');
      }, 70);
    },
    { passive: true }
  );

  clickPulse.addEventListener(
    'animationend',
    () => {
      clickPulse.classList.remove('is-active');
    }
  );

  document.addEventListener(
    'mouseleave',
    hideCursor
  );

  window.addEventListener(
    'blur',
    hideCursor
  );

  document.addEventListener(
    'mouseenter',
    showCursor
  );

  document.documentElement.classList.add(
    'isekaid-rune-cursor-ready'
  );

  const disableCursor = () => {
    document.documentElement.classList.remove(
      'isekaid-rune-cursor-ready'
    );

    cursor.remove();
  };

  finePointer.addEventListener?.(
    'change',
    (event) => {
      if (!event.matches) {
        disableCursor();
      }
    }
  );

  reducedMotion.addEventListener?.(
    'change',
    (event) => {
      if (event.matches) {
        disableCursor();
      }
    }
  );
})();